import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

const inputVariants = cva(
  "flex w-full bg-transparent text-sm md:text-base font-normal file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-zinc-500 disabled:cursor-not-allowed disabled:opacity-50 leading-none",
  {
    variants: {
      inputSize: {
        default: "h-9 px-3",
        sm: "h-8 px-2",
        lg: "h-11 px-4",
      },
    },
    defaultVariants: {
      inputSize: "default",
    },
  }
)

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {
  inputSize?: "default" | "sm" | "lg";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, inputSize, type = "text", ...props }, ref) => {
    return (
      <input
        type={type}
        className={inputVariants({ inputSize, className })}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = "Input"

export { Input, inputVariants }
